// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1WC-K","header":"MessagesList_header__1qTJA","chat":"MessagesList_chat__2x1NZ"};